import queryString from "query-string";

const useQuery = ()=>{
    return queryString.parse(window.location.search);
}

export default useQuery